import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {WebsiteTag} from "../../website/website-tag";
import {FormControl, FormGroup} from "@angular/forms";
import {DbValidators} from "../../../shared/validators/DbValidators";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {WebsiteService} from "../../website.service";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {RemoveTagDialogComponent} from "../remove-tag-dialog/remove-tag-dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {Utils} from "../../../shared/utils/utils";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-tag-item',
    templateUrl: './tag-item.component.html',
    styleUrls: ['./tag-item.component.scss'],
    standalone: false
})

export class TagItemComponent implements OnInit {
  @Input() tag: WebsiteTag;
  @Input() addedTag?: string;
  @Input() domainIds?: any;
  @Output() closeDialog = new EventEmitter<any>();
  @Output() checkedTag = new EventEmitter<any>();
  public tagDefaultData: WebsiteTag;
  public websiteTagsForm: FormGroup;
  public editTag: boolean = false;
  public loading: boolean;
  public checked: boolean;

  constructor(
    private _websiteService: WebsiteService,
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.tagDefaultData = { ...this.tag};
    this.websiteTagsForm = new FormGroup({
      'tagTitle': new FormControl("", [DbValidators.trimStart]),
      'tagChecked': new FormControl("")
    });
    this.compareDomainsArrays();
  }

  public compareDomainsArrays(): void {
    const canCompareArrays = !TypeUtils.isEmpty((this.tag.domains)) && !TypeUtils.isEmpty(this.domainIds);
    if (canCompareArrays) {
      this.tag.allDomainsHas = this.domainIds.length === 1
        ? this.tag.domains.includes(this.domainIds[0]) : Utils.arraysEqual(this.domainIds, this.tag.domains);
      this.tag.someDomainsHas = Utils.compareArrays(this.domainIds, this.tag.domains);
    }
    else if (TypeUtils.isDefined(this.addedTag) && this.addedTag === this.tag.title) {
      this.tag.allDomainsHas = true;
      this.tag.domains = this.domainIds;
      this.checkedTag.emit([this.tag, true]);
    }

    this.tag.clickedValue = this.tag.allDomainsHas ? 'all' : (this.tag.someDomainsHas.length ? 'some' : 'none');
  }

  public onTagChange(tag): void {
    const overall = (<HTMLInputElement>document.getElementById('input_' + tag.id));
    const tagChecked = this.websiteTagsForm.controls['tagChecked'].value;

    if (!tag.allDomainsHas && tag.someDomainsHas.length) {
      let tagItem = (tag.allDomainsHas || tag.clickedValue === "all") ? 'all' : (tag.someDomainsHas ? 'some' : 'none');
      switch (tagItem) {
        case 'all':
          overall.checked = false;
          tag.domains = [];
          tag.clickedValue = "none";
          break;
        case 'some':
          if ( tag.clickedValue === "all") {
            overall.checked = false;
            tag.domains = [];
            tag.clickedValue = "none";
          }
          else if( tag.clickedValue === "none" ) {
            overall.checked = true;
            tag.domains = this.tagDefaultData.domains;
            tag.clickedValue = "some";
          }
          else {
            overall.checked = true;
            tag.domains = this.domainIds;
            tag.clickedValue = "all";
          }
          break;
        case 'none':
          overall.checked = true;
          if (tag.someDomainsHas) {
            tag.domains = this.tagDefaultData.domains;
            tag.clickedValue = "some";
          }
          else {
            tag.domains = this.domainIds;
            tag.clickedValue = "all";
          }
          break;
      }
    }
    else {
      if (tagChecked) {
        tag.domains = this.domainIds;
      }
      else {
        tag.domains = [];
      }
    }
    this.checkedTag.emit([tag, this.websiteTagsForm.controls['tagChecked'].value]);
  }

  public focusOnTagValue(tag): void {
    this.editTag = true;
    setTimeout(() => {
      const ele = (<HTMLInputElement>document.getElementById("tag_" + tag.id));
      ele.focus();
    }, 100);
  }

  public editTagTest(tag: WebsiteTag): void {
    this.loading = true;
    this._websiteService.editUserTag(this.websiteTagsForm.controls['tagTitle'].value, tag.id)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        this.editTag = false;
        if (response.success) {
          this._store.dispatch( new fromStore.LoadWebsites() );
          this._store.dispatch( new fromStore.LoadWebsiteTags() );
        }
      });
  }

  public removeTag(tag: WebsiteTag): void {
    this.closeDialog.emit("true");
    this._dialogService.addDialog(RemoveTagDialogComponent, {
      tagId: tag.id,
      tagTitle: tag.title,
      domainIds: this.domainIds
    });
  }
}
